<template>
    <div>Loading ...</div>
</template>

<script>
    export default {
    }
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/LoadingSplash.vue